import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import EquationInput from "../../../../components/inputs/EquationInput";

// === GENERATE TASK ===
export function generateTask() {
  const variables = ["x", "y", "z"];
  const variable = variables[Math.floor(Math.random() * variables.length)];

  const a = Math.floor(Math.random() * 9) + 1; // współczynnik przy zmiennej
  const b = Math.floor(Math.random() * 9) + 1; // stała

  const aTerm = a === 1 ? `${variable}` : `${a}${variable}`;
  const bTerm = `${b}`;

  // 1) Czy zaczynamy od wyrażenia ze zmienną czy od stałej
  //    varFirst=true  -> (aTerm - b)(aTerm + b) => aTerm^2 - b^2
  //    varFirst=false -> (b - aTerm)(b + aTerm) => b^2 - aTerm^2
  const varFirst = Math.random() < 0.5;

  // 2) Budujemy oba nawiasy: "minus" i "plus" w wybranym wariancie
  const minusFactor = varFirst
    ? `(${aTerm} - ${bTerm})`
    : `(${bTerm} - ${aTerm})`;
  const plusFactor = varFirst
    ? `(${aTerm} + ${bTerm})`
    : `(${bTerm} + ${aTerm})`;

  // 3) Czy kolejność całych nawiasów to "minus, potem plus" czy "plus, potem minus"
  const minusFirst = Math.random() < 0.5;
  const expression = minusFirst ? `${minusFactor}${plusFactor}` : `${plusFactor}${minusFactor}`;

  // 4) Poprawny wynik zależy od tego, co jest wylosowane jako "pierwsze" w nawiasach
  const aSq = a * a;
  const aTermSq = aSq === 1 ? `${variable}^2` : `${aSq}${variable}^2`;
  const bSq = b * b;

  const expected = varFirst ? `${aTermSq} - ${bSq}` : `${bSq} - ${aTermSq}`;

  return {
    type: "DifferenceOfSquaresTask",
    data: { a, b, variable, expression, expected, aTerm, varFirst }
  };
}

// === RENDER TASK ===
export function renderTask({ data }) {
  return (
    <p>
      Uprość wyrażenie: <InlineMath math={data.expression} />
    </p>
  );
}

// === INPUT ===
export function renderInput(_, userAnswer, onChange, disabled) {
  return <EquationInput value={userAnswer} onChange={onChange} disabled={disabled} />;
}

// === CHECK ANSWER ===
export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "string") {
    return { isCorrect: false, expected: data.expected };
  }

  const normalize = (str) =>
    str
      .replace(/−/g, "-")
      .replace(/\s+/g, "")
      .replace(/\*/g, "")
      .replace(/-/g, "+-")
      .toLowerCase()
      .split("+")
      .filter(Boolean)
      .sort()
      .join("+");

  return {
    isCorrect: normalize(userAnswer) === normalize(data.expected),
    expected: data.expected
  };
}

// === ANSWER ===
export function renderAnswer({ data }) {
  return <InlineMath math={data.expected} />;
}

// === EXPLANATION ===
export function renderExplanation({ data }) {
  const { a, b, variable, expression, expected, varFirst } = data;

  const aTerm = a === 1 ? `${variable}` : `${a}${variable}`;

  // Dopasowujemy (p - q)(p + q) = p^2 - q^2 do wylosowanego wariantu
  const p = varFirst ? aTerm : `${b}`;
  const q = varFirst ? `${b}` : aTerm;

  const pSq = varFirst ? (a === 1 ? `${variable}^2` : `(${a}${variable})^2`) : `${b}^2`;
  const qSq = varFirst ? `${b}^2` : (a === 1 ? `${variable}^2` : `(${a}${variable})^2`);

  const substitution = `${pSq} - ${qSq}`;

  return (
    <div className="space-y-2">
      <p><strong>Krok 1:</strong> Wzór różnicy kwadratów:</p>
      <BlockMath math={"(p - q)(p + q) = p^2 - q^2"} />
      <p><strong>Krok 2:</strong> Podstawiamy i liczymy:</p>
      <BlockMath math={`${expression} = ${substitution} = ${expected}`} />
    </div>
  );
}

// === RENDER USER ANSWER ===
export function renderUserAnswer(...args) {
  const ua = args.length === 1 ? args[0] : args[1];
  const raw = typeof ua === "string" ? ua : ua?.raw;
  if (!raw || raw.trim() === "") return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={raw} />;
}
